module.exports = __webpack_public_path__ + "static/media/ULTRACEMCO.e6f2c630.txt";